import defaultsDeep from 'lodash.defaultsdeep';
import * as themeOrange from './orange';
export var name = 'sosh';
var breakpoints = themeOrange.breakpoints,
    grid = themeOrange.grid,
    buttons = themeOrange.buttons,
    alert = themeOrange.alert,
    accordion = themeOrange.accordion,
    bulletList = themeOrange.bulletList,
    input = themeOrange.input,
    checkboxList = themeOrange.checkboxList,
    itemList = themeOrange.itemList,
    stepBar = themeOrange.stepBar;
export { breakpoints, grid, buttons, alert, accordion, bulletList, input, checkboxList, itemList, stepBar };
export var colors = defaultsDeep({
  primary1: '#DE2554',
  primary2: '#FBCD00',
  primary3: '#26828E',
  grey2: '#F4F4F4'
}, themeOrange.colors);
export var text = defaultsDeep({
  shared: {
    normal: {
      fontFamily: 'Sosh Medium, Arial, sans-serif'
    },
    bold: {
      fontFamily: 'Sosh Bold, Arial, sans-serif'
    }
  }
}, themeOrange.text);
export var heading = defaultsDeep({
  shared: {
    fontFamily: 'Sosh Bold, Arial, sans-serif'
  }
}, themeOrange.heading);
export var button = {
  shared: defaultsDeep({
    borderWidth: 2,
    borderRadius: 3,
    paddingTop: 12,
    paddingBottom: 12
  }, themeOrange.button.shared),
  full: {
    white: {
      inactive: {
        color: 'white',
        backgroundColor: 'primary1',
        borderColor: 'primary1'
      },
      hover: {
        color: 'white',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      focus: {
        outlineColor: 'primary1'
      },
      active: {
        color: 'white',
        backgroundColor: 'primary1',
        borderColor: 'primary1'
      },
      disabled: {
        color: 'white',
        backgroundColor: 'grey4',
        borderColor: 'grey4'
      }
    },
    black: {
      inactive: {
        color: 'black',
        backgroundColor: 'primary2',
        borderColor: 'primary2'
      },
      hover: {
        color: 'black',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      focus: {
        outlineColor: 'primary2'
      },
      active: {
        color: 'black',
        backgroundColor: 'primary2',
        borderColor: 'primary2'
      },
      disabled: {
        color: 'black',
        backgroundColor: 'grey3',
        borderColor: 'grey3'
      }
    },
    primary2: {
      inactive: {
        color: 'primary2',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      hover: {
        color: 'black',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      focus: {
        outlineColor: 'black'
      },
      active: {
        color: 'primary2',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      disabled: {
        color: 'white',
        backgroundColor: 'grey4',
        borderColor: 'grey4'
      }
    },
    primary1: {
      inactive: {
        color: 'primary1',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      hover: {
        color: 'white',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      focus: {
        outlineColor: 'white'
      },
      active: {
        color: 'primary1',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      disabled: {
        color: 'black',
        backgroundColor: 'grey3',
        borderColor: 'grey3'
      }
    },
    primary3: {
      inactive: {
        color: 'primary3',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      hover: {
        color: 'white',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      focus: {
        outlineColor: 'white'
      },
      active: {
        color: 'primary3',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      disabled: {
        color: 'black',
        backgroundColor: 'grey3',
        borderColor: 'grey3'
      }
    }
  },
  wired: {
    white: {
      inactive: {
        color: 'primary1',
        backgroundColor: 'transparent',
        borderColor: 'primary1'
      },
      hover: {
        color: 'black',
        backgroundColor: 'transparent',
        borderColor: 'black'
      },
      focus: {
        outlineColor: 'primary1'
      },
      active: {
        color: 'primary1',
        backgroundColor: 'transparent',
        borderColor: 'primary1'
      },
      disabled: {
        color: 'grey4',
        backgroundColor: 'transparent',
        borderColor: 'grey4'
      }
    },
    black: {
      inactive: {
        color: 'primary2',
        backgroundColor: 'transparent',
        borderColor: 'primary2'
      },
      hover: {
        color: 'white',
        backgroundColor: 'transparent',
        borderColor: 'white'
      },
      focus: {
        outlineColor: 'primary2'
      },
      active: {
        color: 'primary2',
        backgroundColor: 'transparent',
        borderColor: 'primary2'
      },
      disabled: {
        color: 'grey3',
        backgroundColor: 'transparent',
        borderColor: 'grey3'
      }
    },
    primary2: {
      inactive: {
        color: 'black',
        backgroundColor: 'transparent',
        borderColor: 'black'
      },
      hover: {
        color: 'black',
        backgroundColor: 'white',
        borderColor: 'white'
      },
      focus: {
        outlineColor: 'black'
      },
      active: {
        color: 'black',
        backgroundColor: 'transparent',
        borderColor: 'black'
      },
      disabled: {
        color: 'grey4',
        backgroundColor: 'transparent',
        borderColor: 'grey4'
      }
    },
    primary1: {
      inactive: {
        color: 'white',
        backgroundColor: 'transparent',
        borderColor: 'white'
      },
      hover: {
        color: 'white',
        backgroundColor: 'black',
        borderColor: 'black'
      },
      focus: {
        outlineColor: 'white'
      },
      active: {
        color: 'white',
        backgroundColor: 'transparent',
        borderColor: 'white'
      },
      disabled: {
        color: 'grey3',
        backgroundColor: 'transparent',
        borderColor: 'grey3'
      }
    }
  }
};
button.full.grey2 = button.full.white;
button.full.grey1 = button.full.black;
button.wired.grey2 = button.wired.white;
button.wired.grey1 = button.wired.black;
button.wired.functionalSuccess = button.wired.primary2;
button.wired.functionalError = button.wired.primary2;
button.wired.functionalInfo = button.wired.primary2;
button.wired.functionalAlert = button.wired.primary2;
button.wired.functionalDimmedSuccess = button.wired.primary2;
button.wired.functionalDimmedError = button.wired.primary2;
button.wired.functionalDimmedInfo = button.wired.primary2;
button.wired.functionalDimmedAlert = button.wired.primary2;
button.wired.photoLight = button.wired.primary2;
button.wired.primary3 = button.wired.primary1;
export var link = defaultsDeep({
  bgWhite: {
    focus: {
      color: 'primary1',
      textDecorationColor: 'primary1'
    },
    active: {
      color: 'black',
      textDecorationColor: 'black'
    }
  },
  bgBlack: {
    focus: {
      color: 'primary2',
      textDecorationColor: 'primary2'
    },
    active: {
      color: 'white',
      textDecorationColor: 'white'
    }
  }
}, themeOrange.link);
export var arrowLink = defaultsDeep({
  shared: {
    next: {
      bgWhite: {
        inactive: {
          color: 'primary1'
        },
        focus: {
          color: 'black',
          textDecorationColor: 'black'
        }
      },
      bgBlack: {
        inactive: {
          color: 'primary2'
        },
        focus: {
          color: 'white',
          textDecorationColor: 'white'
        }
      }
    },
    previous: {
      bgWhite: {
        focus: {
          color: 'black',
          textDecorationColor: 'black'
        }
      },
      bgBlack: {
        focus: {
          color: 'white',
          textDecorationColor: 'white'
        }
      }
    }
  }
}, themeOrange.arrowLink);
arrowLink.shared.up = arrowLink.shared.previous;
arrowLink.shared.down = arrowLink.shared.previous;
export var checkbox = defaultsDeep({
  shared: {
    borderRadius: 3
  },
  checked: {
    inactive: {
      borderWidth: 1,
      backgroundColor: 'primary1',
      tickColor: 'white'
    },
    hover: {
      borderWidth: 1,
      borderColor: 'black',
      backgroundColor: 'black',
      tickColor: 'white'
    },
    active: {
      borderWidth: 2,
      borderColor: 'black',
      tickColor: 'black'
    },
    disabled: {
      borderWidth: 1,
      backgroundColor: 'grey4',
      tickColor: 'white'
    }
  },
  unchecked: {
    hover: {
      borderWidth: 2,
      borderColor: 'black'
    },
    active: {
      borderWidth: 1,
      borderColor: 'black',
      backgroundColor: 'black'
    }
  }
}, themeOrange.checkbox);